import React, { useContext, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import "./Mainpage.css";
import Modules from "../../components/Modules/Modules";
import Widget from "../../components/Widget/Widget";
import Dock from "../../components/Dock/Dock";
import { GeneralContext } from "../../GeneralProvider";
import ChatBar from "../../components/ChatBar/ChatBar";
import GooglePlayLogo from "../../assets/googleplay.png";
import AppStoreLogo from "../../assets/AppStoreLogo.png";
// import LanguageSelect from '../../components/LanguageSelect'

export default function Mainpage() {
  const { emailInvitationCode, handleCollaboratorInvitationByEmail } = useContext(GeneralContext);

  const [showMobilePrompt, setShowMobilePrompt] = useState(false);
  const [hasSeenPrompt, setHasSeenPrompt] = useState(
    localStorage.getItem("mobilePromptSeen") === "true"
  );
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (emailInvitationCode) {
      handleCollaboratorInvitationByEmail();
    }
  }, []);

  useEffect(() => {
    // if (
    //   isMobile &&
    //   JSON.parse(localStorage.getItem("rememberMe") || "false") &&
    //   !hasSeenPrompt
    // )

    if (
      isMobile
    ) {
      setShowMobilePrompt(true);
    }
  }, []);

  if (showMobilePrompt) {
    return (
      <div className="mobile-prompt">
        <h2>Welcome to the Lodos.io desktop panel</h2>
        <p>You logged in succesfully!</p>
        <p>For a better experience on your phone, download our mobile app:</p>
        <div className="mobile-links">
          <span>Android App:</span>
          <a href="https://play.google.com/store/apps/details?id=io.lodos.app&pli=1"><img style={{ width: '90px', height: '90px' }} src={GooglePlayLogo} /></a>
          <span>iOS App</span>
          <a href="https://apps.apple.com/tr/app/lodos-io/id6745250622"><img style={{ width: '90px', height: '90px' }} src={AppStoreLogo} /></a>
        </div>
        {/* <button
          onClick={() => {
            localStorage.setItem("mobilePromptSeen", "true");
            setHasSeenPrompt(true);
            setShowMobilePrompt(false);
          }}
          className="continue-web"
        >
          Continue on the web
        </button> */}
      </div>
    );
  }

  return (
    <div className="main-container">
      <Header />
      <div className="inner-container">
        <Modules />
      </div>
      {/* <Widget /> */}
      <Dock />
      {/* <ChatBar /> */}
    </div>
  );
}
